import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  min-width: 167px;
  max-width: 290px;

  img {
    height: 64px;
    width: 64px;
    border-radius: 4px;
    margin-bottom: 16px;
  }
`;

export const Label = styled.h3`
  margin: 4px 0;
  color: ${Palette.PrimaryGray._700};
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;

export const AppPreview = styled.div`
  padding: 16px;
  img {
    min-height: 64px;
    min-width: 64px;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const WwwTag = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Palette.Primary._500};
  color: white;
  font-size: 7px;
  font-weight: 700;
  line-height: 1;
  padding: 2px 3px;
  border-bottom-right-radius: 3px;
`;
